<template>
    <div>
        <wap-header></wap-header>
            <div style="background: #ffffff" class="aboutUsWap">
            <!--导航栏-->
                <div class="aboutUsNavWap">
                    <div :class="activeName==1?'active':''" @click="btn_tab(1)">公司介绍</div>
                    <div :class="activeName==2?'active':''" @click="btn_tab(2)">职业机会</div>
                    <div :class="activeName==3?'active':''" @click="btn_tab(3)">联系我们</div>
                </div>
            <!--导航栏end-->
            <!--内容-->
                <div class="aboutUsContent">
                    <div v-if="activeName == 1">
                        <wap-company-introduction></wap-company-introduction>
                    </div>
                    <div v-if="activeName == 2">
                        <wap-career-opportunities></wap-career-opportunities>
                    </div>
                    <div v-if="activeName == 3">
                        <wap-contact-us></wap-contact-us>
                    </div>
                </div>
              <!--内容end-->
            </div>
        <wap-footer></wap-footer>
    </div>
</template>

<script>
    import wapHeader from "@/components/wap/headers";
    import wapFooter from "@/components/wap/footers";
    import wapCompanyIntroduction from "@/views/aboutUs/component/wapCompanyIntroduction.vue";
    import wapContactUs from "@/views/aboutUs/component/wapContactUs.vue";
    import wapCareerOpportunities from "@/views/aboutUs/component/wapCareerOpportunities.vue";
    export default {
        name: "aboutWap",
        components:{wapHeader, wapFooter,wapCompanyIntroduction,wapContactUs,wapCareerOpportunities},
        data(){
            return{
                activeName:1
            }
        },
        watch:{
            '$route': function (to, from) {
                if(this.$route.query.type){
                    this.activeName = this.$route.query.type;
                }
            }
        },
        mounted() {
            if (this.$route.query.type) {
                this.activeName =this.$route.query.type;
            }
        },
        methods:{
            btn_tab(num){
                this.activeName = num;
            },
        }
    }
</script>

<style scoped>

</style>

<style>
  .aboutUsWap{
      width:390px;
      height:100%;
      margin:55px auto 0;
  }
  .aboutUsWap .aboutUsNavWap{
      width:355px;
      height:46px;
      margin:10px auto 0;
      display: flex;
      background: #007ED2;
      border-radius: 10px 10px 0 0;
  }
  .aboutUsWap .aboutUsNavWap div{
      width:34%;
      height: 46px;
      line-height: 46px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #FFFFFF;
      text-align: center;
      border-radius: 10px 10px 0 0;
  }
  .aboutUsWap .aboutUsNavWap .active{
      background: rgba(0, 0, 0, 0.42);
  }
</style>
